import { render, staticRenderFns } from "./harbor-edit.vue?vue&type=template&id=03112abf&"
import script from "./harbor-edit.vue?vue&type=script&lang=js&"
export * from "./harbor-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports